const mobilePagePans = [
  { page: '23' },
];

export default mobilePagePans;